import classnames from 'classnames';

interface SomethingWentWrongMessageProps {
  title?: string;
  copy?: string;
  isPageContext?: boolean;
}

const SomethingWentWrongMessage = ({
  title,
  copy,
  isPageContext
}: SomethingWentWrongMessageProps) => {
  return (
    <div className="mb-80 md:grid md:grid-cols-12">
      <div
        className={classnames('flex flex-col gap-8', isPageContext ? 'col-span-7' : 'col-span-12')}
      >
        <div className="heading-6-medium">
          {title ?? "We're sorry, it seems like something went wrong."}
        </div>
        <div
          className="[&_a]:text-link text-gray-dark [&_a]:text-gray-dark [&_a]:underline"
          dangerouslySetInnerHTML={{
            __html:
              copy ??
              "Please double-check your address details. If everything looks correct and you're still having trouble, contact customer service at 800.260.4754 or visit our Help Center."
          }}
        />
      </div>
    </div>
  );
};

export default SomethingWentWrongMessage;
